// extracted by mini-css-extract-plugin
module.exports =  {"value":"skins-noValue-value-ef413f7d"};